var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        name: _vm.transition,
        mode: "in-out",
        appear: "",
        "appear-active-class": _vm.enterClass,
        "enter-active-class": _vm.enterClass,
        "leave-active-class": _vm.leaveClass,
      },
      on: { beforeEnter: _vm.beforeEnter, afterLeave: _vm.afterLeave },
    },
    [
      _vm.show
        ? _c("div", { class: _vm.classes }, [
            _c("div", { staticClass: "modal-background" }),
            _c("div", { staticClass: "modal-card", style: _vm.customStyle }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
                _c("button", {
                  staticClass: "delete",
                  on: { click: _vm.deactive },
                }),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [_vm._t("default")],
                2
              ),
              _c(
                "footer",
                {
                  staticClass: "modal-card-foot",
                  staticStyle: { "justify-content": "flex-end" },
                },
                [
                  _c(
                    "a",
                    { staticClass: "button is-primary", on: { click: _vm.ok } },
                    [_vm._v(_vm._s(_vm.okText))]
                  ),
                  _c(
                    "a",
                    { staticClass: "button", on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.cancelText))]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }